export default __webpack_public_path__ + "static/media/IBimagesSwinglegrecovery2.0cb56931.png";